'use es6';

import { ADS_PROPERTIES } from 'reference-resolvers/constants/CacheKeys';
import { getAllAdsProperties, createGetAllAdsProperties } from 'reference-resolvers/api/AdsPropertiesApi';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createAdsPropertyReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: ADS_PROPERTIES,
  createFetchData: createGetAllAdsProperties,
  fetchData: getAllAdsProperties
}, options));
export default createAdsPropertyReferenceResolver();